@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.headerWrapper {
  margin-top:  hevo-toolkit-variables.$spacer * 2.5;
}

.linkHolder {
  display: flex;
  align-items: center;
  color: var(--text-default-color) !important;
  padding-right:  hevo-toolkit-variables.$spacer * 1.25;
  margin-top: 0;
  white-space: pre;
}

.noticeBadge {
  display: flex;
  align-items: center;
  padding:  hevo-toolkit-variables.$spacer * 0.75  hevo-toolkit-variables.$spacer;
  border-radius:  hevo-toolkit-variables.$border-radius-md;
  background: var(--info-faded-color);
  border: solid var(--border-width) var(--info-border-color);
}

.orHolder {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin:  hevo-toolkit-variables.$spacer * 1.9 0;
  .divider {
    border-bottom: solid var(--border-width) var(--divider-color);
    display: inline-flex;
    width: 155px;
  }

  .text {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:  hevo-toolkit-variables.$font-size-caption;
    font-weight:  hevo-toolkit-variables.$font-weight-bold;
    border: solid var(--border-width) var(--divider-color);
    border-radius: 50%;
  }
}
